// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import jwtDecode from "jwt-decode";
// import api from "./axiosConfig";
// import { LogOut, ChevronRight, CreditCard, User, MessageSquare, FileText, Video, Zap, Target, X, Loader2, Search } from "lucide-react";
// import OnboardingChecklist from "./OnboardingChecklist";

// const CoreDashboard = () => {
//   // State management
//   const [user, setUser] = useState(null);
//   const [userCredits, setUserCredits] = useState({
//     question_credits: null,
//     report_credits: null,
//     video_credits: null,
//     ideation_credits: null,
//     lead_credits: null,
//     plan_name: null,
//     subscription_active: false,
//     first_name: "Guest",
//     email: "",
//   });
//   const [isLoading, setIsLoading] = useState(true);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Enhanced onboarding state management
//   // const [showOnboarding, setShowOnboarding] = useState(() => {
//   //   // Check if there are incomplete tasks
//   //   const progress = localStorage.getItem("onboardingProgress");
//   //   const stage = localStorage.getItem("selectedStage");

//   //   if (!progress || !stage) {
//   //     return true; // Show onboarding if no progress or stage is saved
//   //   }

//   //   const completedTasks = JSON.parse(progress);
//   //   return completedTasks.length < 4; // Show if not all tasks are completed
//   // });

//   // To enable onboarding
//   // const [showOnboarding, setShowOnboarding] = useState(() => {
//   //   const hasSeen = localStorage.getItem("hasSeenOnboarding");
//   //   return hasSeen !== "true";
//   // });
//   const [showOnboarding, setShowOnboarding] = useState(false);

//   const [showWelcomeBanner, setShowWelcomeBanner] = useState(() => {
//     const justCompletedOnboarding = localStorage.getItem("justCompletedOnboarding");
//     if (justCompletedOnboarding) {
//       localStorage.removeItem("justCompletedOnboarding");
//       return true;
//     }
//     return false;
//   });

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Check for incomplete onboarding on mount
//   // useEffect(() => {
//   //   const checkOnboardingStatus = () => {
//   //     const progress = localStorage.getItem("onboardingProgress");
//   //     const stage = localStorage.getItem("selectedStage");

//   //     if (!progress || !stage) {
//   //       setShowOnboarding(true);
//   //       return;
//   //     }

//   //     const completedTasks = JSON.parse(progress);
//   //     if (completedTasks.length < 4) {
//   //       setShowOnboarding(true);
//   //     }
//   //   };

//   //   if (!isLoading && userCredits) {
//   //     checkOnboardingStatus();
//   //   }
//   // }, [isLoading, userCredits]);

//   // Authentication check
//   useEffect(() => {
//     const token = localStorage.getItem("access");
//     if (!token) {
//       setIsLoading(false);
//       window.location.href = "/signin/";
//       return;
//     }

//     try {
//       const decodedToken = jwtDecode(token);
//       const currentTimestamp = Math.floor(Date.now() / 1000);

//       if (decodedToken.exp && decodedToken.exp < currentTimestamp) {
//         console.warn("Token expired.");
//         localStorage.removeItem("access");
//         setIsLoading(false);
//         window.location.href = "/signin/";
//       } else {
//         setUser(decodedToken);
//         if (decodedToken.first_name) {
//           setUserCredits((prev) => ({ ...prev, first_name: decodedToken.first_name }));
//         }
//       }
//     } catch (error) {
//       console.error("Failed to decode token:", error);
//       localStorage.clear();
//       setIsLoading(false);
//       window.location.href = "/signin/";
//     }
//   }, []);

//   // Fetch user credits
//   useEffect(() => {
//     if (user) {
//       const fetchUserCredits = async () => {
//         try {
//           const response = await api.get("get-user-credits/");
//           if (response.data) {
//             setUserCredits({
//               ...response.data,
//               first_name: response.data.first_name || user.first_name || "User",
//               question_credits: response.data.question_credits ?? 0,
//               report_credits: response.data.report_credits ?? 0,
//               video_credits: response.data.video_credits ?? 0,
//               ideation_credits: response.data.ideation_credits ?? 0,
//               lead_credits: response.data.lead_credits ?? 0,
//             });
//           }
//         } catch (error) {
//           console.error("Error fetching user credits:", error);
//         } finally {
//           setIsLoading(false);
//         }
//       };
//       fetchUserCredits();
//     } else if (!localStorage.getItem("access")) {
//       setIsLoading(false);
//     }
//   }, [user]);

//   const handleLogout = () => {
//     localStorage.clear();
//     window.location.href = "/signin/";
//   };

//   // const handleOnboardingClose = () => {
//   //   const progress = localStorage.getItem("onboardingProgress");
//   //   const completedTasks = progress ? JSON.parse(progress) : [];

//   //   // Only allow closing if all tasks are completed
//   //   if (completedTasks.length >= 4) {
//   //     setShowOnboarding(false);
//   //     localStorage.setItem("hasSeenOnboarding", "true");
//   //     localStorage.setItem("justCompletedOnboarding", "true");
//   //     setShowWelcomeBanner(true);
//   //   }
//   // };

//   const handleOnboardingClose = () => {
//     setShowOnboarding(false);
//     localStorage.setItem("hasSeenOnboarding", "true");
//   };

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-white flex items-center justify-center">
//         <Loader2 className="w-12 h-12 text-green-600 animate-spin" />
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen">
//       {showOnboarding && (
//         <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 overflow-y-auto">
//           <OnboardingChecklist
//             userName={userCredits.first_name}
//             onTaskClick={(path) => {
//               window.location.href = path;
//             }}
//             onClose={handleOnboardingClose}
//           />
//         </div>
//       )}

//       <header className="h-16 border-b border-gray-200 flex items-center px-4 sm:px-8 sticky top-0 bg-white backdrop-blur-sm z-20">
//         <div className="max-w-7xl mx-auto flex justify-between items-center w-full">
//           <span className="font-semibold text-xl text-green-600">FeedbackbyAI</span>

//           <div ref={dropdownRef} className="relative user-dropdown">
//             <button
//               className="flex items-center space-x-2 p-1.5 rounded-full hover:bg-gray-100 transition-colors"
//               onClick={() => setDropdownOpen(!dropdownOpen)}
//             >
//               <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center ring-1 ring-green-200">
//                 <User className="w-5 h-5 text-green-600" />
//               </div>
//               <span className="hidden sm:inline text-sm font-medium text-gray-700 pr-1">{userCredits.first_name}</span>
//             </button>

//             {dropdownOpen && (
//               <motion.div
//                 initial={{ opacity: 0, y: -5 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -5 }}
//                 transition={{ duration: 0.15 }}
//                 className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-xl py-1 z-30 border border-gray-200/80"
//               >
//                 <div className="px-4 py-2 border-b border-gray-100">
//                   <p className="text-sm font-medium truncate">{userCredits.first_name}</p>
//                 </div>
//                 <Link to="/credits/" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
//                   <CreditCard className="w-4 h-4 mr-2 text-gray-400" /> View Credits & Usage
//                 </Link>
//                 <button
//                   onClick={() => setShowOnboarding(true)}
//                   className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
//                 >
//                   <Target className="w-4 h-4 mr-2 text-gray-400" /> View Onboarding
//                 </button>
//                 <button
//                   onClick={handleLogout}
//                   className="flex items-center w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
//                 >
//                   <LogOut className="w-4 h-4 mr-2" /> Sign Out
//                 </button>
//               </motion.div>
//             )}
//           </div>
//         </div>
//       </header>

//       <AnimatePresence>
//         {showWelcomeBanner && (
//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -20 }}
//             className="bg-emerald-50 border-b border-emerald-100"
//           >
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
//               <div className="flex items-center justify-between">
//                 <p className="text-sm text-emerald-800">
//                   <span className="font-medium">Welcome to your dashboard!</span> You can always reopen the onboarding guide from your
//                   profile menu.
//                 </p>
//                 <button onClick={() => setShowWelcomeBanner(false)} className="text-emerald-800 hover:text-emerald-600">
//                   <X className="w-5 h-5" />
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <main className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
//         <div className="flex flex-col items-center justify-center mb-10 sm:mb-14 text-center">
//           <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mb-5 sm:mb-6 ring-4 ring-white shadow-md">
//             <User className="w-8 h-8 sm:w-10 sm:h-10 text-green-600" />
//           </div>
//           <motion.h1
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//             className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2"
//           >
//             Welcome, {userCredits.first_name !== "Guest" ? userCredits.first_name : "Explorer"}!
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: -10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.1 }}
//             className="text-base text-gray-600 max-w-lg mx-auto"
//           >
//             What would you like to do today?
//           </motion.p>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6 mb-12">
//           <Link to="/ideate/" className="group">
//             <motion.div
//               whileHover={{ y: -3 }}
//               transition={{ duration: 0.2 }}
//               className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col"
//             >
//               <div className="w-16 h-16 rounded-full bg-purple-50 flex items-center justify-center mb-4">
//                 <Zap className="w-8 h-8 text-purple-600" />
//               </div>
//               <h2 className="text-xl font-semibold mb-3 text-gray-900">
//                 {/* Ideate */}
//                 🔍 Brainstorm Idea or Feature
//               </h2>
//               <p className="text-sm text-gray-600 mb-6 flex-grow">
//                 {/* Discover winning ideas from social media conversations and market research. */}
//                 Find unmet needs, pain points worth solving by analyzing real-time conversations.
//               </p>
//               <div className="mt-auto">
//                 <span className="inline-flex items-center text-purple-600 font-medium hover:text-purple-800 transition-colors">
//                   {/* Find Ideas */}
//                   Start Discovering →{/* <ChevronRight className="ml-1 w-4 h-4" /> */}
//                 </span>
//               </div>
//             </motion.div>
//           </Link>

//           <Link to="/report/" className="group">
//             <motion.div
//               whileHover={{ y: -3 }}
//               transition={{ duration: 0.2 }}
//               className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col"
//             >
//               <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mb-4">
//                 <FileText className="w-8 h-8 text-green-600" />
//               </div>
//               <h2 className="text-xl font-semibold mb-3 text-gray-900">
//                 {/* Validate */}
//                 {/* 🧪 Validate Your Concept */}
//                 📊 Generate Business Plan
//               </h2>
//               <p className="text-sm text-gray-600 mb-6 flex-grow">
//                 {/* Generate a comprehensive 100+ page business plan in minutes to validate your concept. */}
//                 Get utmost clarity with a 100+ page comprehensive business plan in minutes.
//               </p>
//               <div className="mt-auto">
//                 <span className="inline-flex items-center text-green-600 font-medium hover:text-green-800 transition-colors">
//                   {/* Start Validation */}
//                   Create Your Plan →{/* <ChevronRight className="ml-1 w-4 h-4" /> */}
//                 </span>
//               </div>
//             </motion.div>
//           </Link>

//           {/* <Link to="/feedback/" className="group">
//             {" "}
//             <motion.div
//               whileHover={{ y: -3 }}
//               transition={{ duration: 0.2 }}
//               className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col"
//             >
//               <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-4">
//                 <MessageSquare className="w-8 h-8 text-blue-600" />
//               </div>
//               <h2 className="text-xl font-semibold mb-3 text-gray-900">User Interviews</h2>
//               <p className="text-sm text-gray-600 mb-6 flex-grow">
//                 Run AI character interviews to get honest feedback on your product or idea.
//               </p>
//               <div className="mt-auto">
//                 <span className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors">
//                   Start Interviews
//                   <ChevronRight className="ml-1 w-4 h-4" />
//                 </span>
//               </div>
//             </motion.div>
//           </Link> */}

//           <Link to="/leadfinder/" className="group">
//             <motion.div
//               whileHover={{ y: -3 }}
//               transition={{ duration: 0.2 }}
//               className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col"
//             >
//               <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-4">
//                 <Search className="w-8 h-8 text-blue-600" />
//               </div>
//               <h2 className="text-xl font-semibold mb-3 text-gray-900">
//                 {/* Promote */}
//                 🚀 Real-Time Buyer Intent Search
//               </h2>
//               <p className="text-sm text-gray-600 mb-6 flex-grow">
//                 {/* Create automated videos to drive traffic to your website and convert visitors. */}
//                 {/* Create TikToks that drive qualified traffic to your site */}
//                 Search for buying signals multiple times daily to find fresh leads.
//               </p>
//               <div className="mt-auto">
//                 <span className="inline-flex items-center text-blue-600 font-medium hover:text-orange-800 transition-colors">
//                   {/* Start Promotion */}
//                   Search Leads →{/* <ChevronRight className="ml-1 w-4 h-4" /> */}
//                 </span>
//               </div>
//             </motion.div>
//           </Link>

//           <Link to="/video/" className="group">
//             <motion.div
//               whileHover={{ y: -3 }}
//               transition={{ duration: 0.2 }}
//               className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col"
//             >
//               <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center mb-4">
//                 <Video className="w-8 h-8 text-orange-600" />
//               </div>
//               <h2 className="text-xl font-semibold mb-3 text-gray-900">
//                 {/* Promote */}
//                 🚀 Automate TikTok & Reels
//                 {/* Automate Your Marketing */}
//               </h2>
//               <p className="text-sm text-gray-600 mb-6 flex-grow">
//                 {/* Create automated videos to drive traffic to your website and convert visitors. */}
//                 Automate daily TikToks/Reels/Shorts that drive product awareness and traffic.
//               </p>
//               <div className="mt-auto">
//                 <span className="inline-flex items-center text-orange-600 font-medium hover:text-orange-800 transition-colors">
//                   {/* Start Promotion */}
//                   Create Videos →{/* <ChevronRight className="ml-1 w-4 h-4" /> */}
//                 </span>
//               </div>
//             </motion.div>
//           </Link>

//           {/* <Link to="/leadfinder/" className="group">
//             <motion.div
//               whileHover={{ y: -3 }}
//               transition={{ duration: 0.2 }}
//               className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 hover:shadow-2xl transition-shadow duration-300 h-full flex flex-col"
//             >
//               <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-4">
//                 <Target className="w-8 h-8 text-red-600" />
//               </div>
//               <h2 className="text-xl font-semibold mb-3 text-gray-900">Lead Finder</h2>
//               <p className="text-sm text-gray-600 mb-6 flex-grow">Find qualified leads that are ready to buy your product or service.</p>
//               <div className="mt-auto">
//                 <span className="inline-flex items-center text-red-600 font-medium hover:text-red-800 transition-colors">
//                   Find Leads
//                   <ChevronRight className="ml-1 w-4 h-4" />
//                 </span>
//               </div>
//             </motion.div>
//           </Link> */}
//         </div>

//         <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
//           <h2 className="text-xl font-bold text-gray-800 mb-5">Your Subscription</h2>

//           <div className="flex items-center mb-4">
//             <span
//               className={`inline-block w-3 h-3 rounded-full mr-2.5 ring-1 ring-offset-1 ${
//                 userCredits.subscription_active ? "bg-green-500 ring-green-100" : "bg-gray-400 ring-gray-100"
//               }`}
//             ></span>
//             <span className="text-lg font-medium text-gray-700">
//               {userCredits.plan_name || "Loading..."} Plan{" "}
//               {!userCredits.subscription_active && userCredits.plan_name !== "Free" && userCredits.plan_name && (
//                 <span className="text-xs text-red-600">(Inactive)</span>
//               )}
//             </span>
//           </div>

//           <div className="mt-4 mb-6 border-t border-gray-100 pt-4">
//             <Link to="/credits/" className="text-sm text-green-600 hover:text-green-800 hover:underline font-medium">
//               View credit details and usage limits
//             </Link>
//             {userCredits.plan_name === "Free" && (
//               <p className="text-sm text-gray-600 mt-2">
//                 Ready for more? <span className="font-medium">Upgrade your plan</span> to unlock powerful features and higher limits!
//               </p>
//             )}
//           </div>

//           <Link
//             to="/credits/"
//             className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white text-base sm:text-lg font-semibold py-2.5 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 shadow hover:shadow-md"
//           >
//             {userCredits.plan_name === "Free" ? "Upgrade Plan Now" : "Manage Subscription"}
//             <ChevronRight className="ml-1.5 w-5 h-5" />
//           </Link>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default CoreDashboard;

// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import jwtDecode from "jwt-decode";
// import api from "./axiosConfig";
// import { LogOut, ChevronRight, CreditCard, User, MessageSquare, FileText, Video, Zap, Target, X, Loader2, Search } from "lucide-react";
// import OnboardingChecklist from "./OnboardingChecklist";
// import EnhancedHeader from "./EnhancedHeader";
// import Logo from "../images/thumbnail.png";

// const CoreDashboard = () => {
//   // State management
//   const [user, setUser] = useState(null);
//   const [userCredits, setUserCredits] = useState({
//     question_credits: null,
//     report_credits: null,
//     video_credits: null,
//     ideation_credits: null,
//     lead_credits: null,
//     plan_name: null,
//     subscription_active: false,
//     first_name: "Guest",
//     email: "",
//   });
//   const [isLoading, setIsLoading] = useState(true);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const [showOnboarding, setShowOnboarding] = useState(false);
//   const [showWelcomeBanner, setShowWelcomeBanner] = useState(() => {
//     const justCompletedOnboarding = localStorage.getItem("justCompletedOnboarding");
//     if (justCompletedOnboarding) {
//       localStorage.removeItem("justCompletedOnboarding");
//       return true;
//     }
//     return false;
//   });

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Authentication check
//   useEffect(() => {
//     const token = localStorage.getItem("access");
//     if (!token) {
//       setIsLoading(false);
//       window.location.href = "/signin/";
//       return;
//     }
//     try {
//       const decodedToken = jwtDecode(token);
//       const currentTimestamp = Math.floor(Date.now() / 1000);
//       if (decodedToken.exp && decodedToken.exp < currentTimestamp) {
//         console.warn("Token expired.");
//         localStorage.removeItem("access");
//         setIsLoading(false);
//         window.location.href = "/signin/";
//       } else {
//         setUser(decodedToken);
//         if (decodedToken.first_name) {
//           setUserCredits((prev) => ({ ...prev, first_name: decodedToken.first_name }));
//         }
//       }
//     } catch (error) {
//       console.error("Failed to decode token:", error);
//       localStorage.clear();
//       setIsLoading(false);
//       window.location.href = "/signin/";
//     }
//   }, []);

//   // Fetch user credits
//   useEffect(() => {
//     if (user) {
//       const fetchUserCredits = async () => {
//         try {
//           const response = await api.get("get-user-credits/");
//           if (response.data) {
//             setUserCredits({
//               ...response.data,
//               first_name: response.data.first_name || user.first_name || "User",
//               email: response.data.email || user.email || "",
//               question_credits: response.data.question_credits ?? 0,
//               report_credits: response.data.report_credits ?? 0,
//               video_credits: response.data.video_credits ?? 0,
//               ideation_credits: response.data.ideation_credits ?? 0,
//               lead_credits: response.data.lead_credits ?? 0,
//             });
//           }
//         } catch (error) {
//           console.error("Error fetching user credits:", error);
//         } finally {
//           setIsLoading(false);
//         }
//       };
//       fetchUserCredits();
//     } else if (!localStorage.getItem("access")) {
//       setIsLoading(false);
//     }
//   }, [user]);

//   const handleLogout = () => {
//     localStorage.clear();
//     window.location.href = "/signin/";
//   };

//   const handleOnboardingClose = () => {
//     setShowOnboarding(false);
//     localStorage.setItem("hasSeenOnboarding", "true");
//   };

//   // Card data with landing page style
//   const actionCards = [
//     {
//       id: "brainstorm",
//       icon: "🧪",
//       title: " Brainstorm Opportunities",
//       description: "Find real customer pain points and unmet needs from Reddit, Twitter & LinkedIn.",
//       cta: "Start Discovering →",
//       path: "/ideate",
//       color: "blue",
//       glow: "shadow-[0_0_35px_-8px_rgba(59,130,246,0.25)]",
//       hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(59,130,246,0.4)]",
//     },
//     {
//       id: "plan",
//       icon: "📊",
//       title: "Create a Business Plan",
//       description: "Get a 100+ page personalized plan in minutes — market research, positioning, and more.",
//       cta: "Create Your Plan →",
//       // path: "/report",
//       path: "/dynamicreports",
//       color: "green",
//       glow: "shadow-[0_0_35px_-8px_rgba(34,197,94,0.25)]",
//       hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(34,197,94,0.4)]",
//     },
//     {
//       id: "leads",
//       icon: "👥",
//       title: "Real-Time Buyer Intent Search",
//       description: "Find fresh leads searching for what you offer — updated every hour.",
//       cta: "Search Leads →",
//       path: "/leadfinder",
//       isPopular: true,
//       color: "purple",
//       glow: "shadow-[0_0_35px_-8px_rgba(168,85,247,0.25)]",
//       hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(168,85,247,0.4)]",
//     },
//     {
//       id: "content",
//       icon: "📱",
//       title: "Launch Your AI Influencer",
//       description: "Automate Reels, TikToks, and Shorts with 50+ avatars — just click, download, and post.",
//       cta: "Create Videos →",
//       path: "/video",
//       color: "orange",
//       glow: "shadow-[0_0_35px_-8px_rgba(249,115,22,0.25)]",
//       hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(249,115,22,0.4)]",
//     },
//   ];

//   const colorClasses = {
//     blue: {
//       bg: "bg-white",
//       border: "border-blue-200",
//       text: "text-blue-900",
//       hoverBg: "hover:bg-blue-50/50",
//       hoverBorder: "hover:border-blue-400",
//       iconBg: "bg-blue-100",
//       iconText: "text-blue-600",
//       ctaColor: "text-blue-600",
//       hoverCtaColor: "group-hover:text-blue-700",
//       gradientFrom: "from-blue-50/50",
//       gradientTo: "to-transparent",
//       popularRing: "ring-blue-500",
//       popularText: "text-blue-700",
//       popularBg: "bg-blue-100",
//     },
//     green: {
//       bg: "bg-white",
//       border: "border-green-200",
//       text: "text-green-900",
//       hoverBg: "hover:bg-green-50/50",
//       hoverBorder: "hover:border-green-400",
//       iconBg: "bg-green-100",
//       iconText: "text-green-600",
//       ctaColor: "text-green-600",
//       hoverCtaColor: "group-hover:text-green-700",
//       gradientFrom: "from-green-50/50",
//       gradientTo: "to-transparent",
//       popularRing: "ring-green-500",
//       popularText: "text-green-700",
//       popularBg: "bg-green-100",
//     },
//     purple: {
//       bg: "bg-white",
//       border: "border-purple-200",
//       text: "text-purple-900",
//       hoverBg: "hover:bg-purple-50/50",
//       hoverBorder: "hover:border-purple-400",
//       iconBg: "bg-purple-100",
//       iconText: "text-purple-600",
//       ctaColor: "text-purple-600",
//       hoverCtaColor: "group-hover:text-purple-700",
//       gradientFrom: "from-purple-50/50",
//       gradientTo: "to-transparent",
//       popularRing: "ring-purple-500",
//       popularText: "text-purple-700",
//       popularBg: "bg-purple-100",
//     },
//     orange: {
//       bg: "bg-white",
//       border: "border-orange-200",
//       text: "text-orange-900",
//       hoverBg: "hover:bg-orange-50/50",
//       hoverBorder: "hover:border-orange-400",
//       iconBg: "bg-orange-100",
//       iconText: "text-orange-600",
//       ctaColor: "text-orange-600",
//       hoverCtaColor: "group-hover:text-orange-700",
//       gradientFrom: "from-orange-50/50",
//       gradientTo: "to-transparent",
//       popularRing: "ring-orange-500",
//       popularText: "text-orange-700",
//       popularBg: "bg-orange-100",
//     },
//   };

//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <Loader2 className="w-12 h-12 text-blue-500 animate-spin" />
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen ">
//       {showOnboarding && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//           <OnboardingChecklist
//             onNavigate={(path) => {
//               window.location.href = path;
//             }}
//             onClose={handleOnboardingClose}
//           />
//         </div>
//       )}

//       <div className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-200">
//         <div className="container mx-auto px-4 py-4 flex items-center justify-between">
//           {/* <div className="text-2xl font-bold text-green-600">FeedbackbyAI</div> */}
//           <div className="flex-shrink-0">
//             <Link to="/dashboard" className="flex items-center">
//               <img src={Logo} alt="FeedbackbyAI Logo" className="h-10" />
//               <span className="ml-3 text-2xl font-bold text-green-600">FeedbackbyAI</span>
//             </Link>
//           </div>
//           <div className="relative" ref={dropdownRef}>
//             <button
//               className="flex items-center px-4 py-2 text-base font-semibold text-gray-700 hover:text-gray-900 transition-colors"
//               onClick={() => setDropdownOpen(!dropdownOpen)}
//             >
//               <User className="w-6 h-6 mr-2" />
//               {userCredits.first_name}
//             </button>
//             {dropdownOpen && (
//               <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg ring-1 ring-black/5 focus:outline-none z-50">
//                 <div className="px-4 py-3 border-b border-gray-100">
//                   <p className="text-sm font-medium text-gray-900">{userCredits.first_name}</p>
//                 </div>
//                 <div className="px-4 py-3 border-b border-gray-100">
//                   <p className="text-sm font-medium text-gray-900">{userCredits.email}</p>
//                 </div>
//                 <Link to="/credits" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
//                   <CreditCard className="w-4 h-4 mr-2" /> View Credits & Usage
//                 </Link>
//                 <button
//                   onClick={() => setShowOnboarding(true)}
//                   className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
//                 >
//                   <Target className="w-4 h-4 mr-2" /> View Onboarding
//                 </button>
//                 <button
//                   onClick={handleLogout}
//                   className="flex items-center w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
//                 >
//                   <LogOut className="w-4 h-4 mr-2" /> Sign Out
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <AnimatePresence>
//         {showWelcomeBanner && (
//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -20 }}
//             className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 mx-4"
//           >
//             <div className="bg-emerald-100 border border-emerald-300 text-emerald-800 px-6 py-3 rounded-lg shadow-lg flex items-center gap-4 max-w-lg">
//               <div className="flex-grow">
//                 <p className="text-emerald-800 font-medium">
//                   Welcome to your dashboard! You can always reopen the onboarding guide from your profile menu.
//                 </p>
//               </div>
//               <button onClick={() => setShowWelcomeBanner(false)} className="text-emerald-800 hover:text-emerald-600">
//                 <X className="w-5 h-5" />
//               </button>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <div className="container mx-auto px-4 py-12">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
//             Welcome, {userCredits.first_name !== "Guest" ? userCredits.first_name : "Explorer"}!
//           </h2>
//           <p className="text-lg text-gray-600 max-w-2xl mx-auto">What would you like to do today?</p>
//         </div>

//         <motion.div
//           initial="hidden"
//           animate="visible"
//           variants={{
//             hidden: { opacity: 0 },
//             visible: { opacity: 1, transition: { delayChildren: 0.3, staggerChildren: 0.18 } },
//           }}
//           className="grid grid-cols-1 md:grid-cols-4 gap-5 md:gap-7 max-w-6xl mx-auto"
//         >
//           {actionCards.map((card) => {
//             const colors = colorClasses[card.color];
//             if (!colors) {
//               console.warn(`Color definition missing for card color: ${card.color}. Skipping card.`);
//               return null;
//             }
//             return (
//               <motion.div
//                 key={card.id}
//                 variants={{
//                   hidden: { opacity: 0, scale: 0.95, y: 30 },
//                   visible: { opacity: 1, scale: 1, y: 0, transition: { type: "spring", damping: 15, stiffness: 100 } },
//                 }}
//                 onClick={() => (window.location.href = card.path)}
//                 className={`
//                   rounded-2xl overflow-hidden border transition-all duration-200
//                   ${colors.bg} ${colors.border} ${colors.text} ${colors.hoverBg} ${colors.hoverBorder}
//                   ${card.glow} ${card.hoverGlow}
//                   h-full cursor-pointer group relative
//                 `}
//               >
//                 <div
//                   className={`absolute inset-0 bg-gradient-to-br ${colors.gradientFrom} ${colors.gradientTo} opacity-50 transition-opacity duration-200 group-hover:opacity-80`}
//                 />

//                 {card.isPopular && (
//                   <div
//                     className={`absolute top-4 right-4 px-3 py-1 rounded-full ${colors.popularBg} ${colors.popularText} text-xs font-semibold`}
//                   >
//                     Popular
//                   </div>
//                 )}

//                 <div className="relative z-10 p-6 sm:p-8 flex flex-col h-full">
//                   <div className={`w-14 h-14 mb-5 flex items-center justify-center rounded-2xl ${colors.iconBg} ${colors.iconText}`}>
//                     <span className="text-2xl">{card.icon}</span>
//                   </div>

//                   <h3 className="text-lg sm:text-2xl font-bold mb-3 sm:mb-5">{card.title}</h3>

//                   <p className="text-sm sm:text-base opacity-90 mb-6 sm:mb-10 flex-grow">{card.description}</p>

//                   <div
//                     className={`flex items-center font-semibold text-sm sm:text-base ${colors.ctaColor} ${colors.hoverCtaColor} transition-colors`}
//                   >
//                     {card.cta}
//                     <ChevronRight className="h-5 w-5 inline transition-transform group-hover:translate-x-1" />
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}
//         </motion.div>

//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 1.0 }}
//           className="mt-12 max-w-xl mx-auto"
//         >
//           <div className="bg-white rounded-2xl p-6 text-center border border-gray-200 hover:border-blue-200 hover:shadow-[0_0_20px_-5px_rgba(59,130,246,0.2)] transition-all duration-300">
//             <h2 className="text-lg font-bold text-gray-900 mb-2">Your Subscription</h2>
//             <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-100 text-green-700 text-sm font-medium mb-4">
//               <CreditCard className="w-4 h-4" />
//               {userCredits.plan_name || "Loading..."} Plan{" "}
//               {!userCredits.subscription_active && userCredits.plan_name !== "Free" && userCredits.plan_name && (
//                 <span className="text-red-600">(Inactive)</span>
//               )}
//             </div>
//             <p className="text-gray-600 mb-4">View credit details and usage limits</p>
//             {userCredits.plan_name === "Free" && (
//               <p className="text-sm text-blue-600 font-medium bg-blue-50 p-3 rounded-lg mb-4">
//                 Ready for more? Upgrade your plan to unlock powerful features and higher limits!
//               </p>
//             )}
//             <Link
//               to="/credits"
//               className="inline-flex items-center px-4 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white transition-colors duration-200"
//             >
//               {userCredits.plan_name === "Free" ? "Upgrade Plan Now" : "Manage Subscription"}
//               <ChevronRight className="w-4 h-4 ml-2" />
//             </Link>
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default CoreDashboard;

import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import jwtDecode from "jwt-decode";
import api from "./axiosConfig";
import {
  LogOut,
  ChevronRight,
  CreditCard,
  User,
  MessageSquare,
  FileText,
  Video,
  Zap,
  Target,
  X,
  Loader2,
  Search,
  Building,
  Calendar,
  Mail,
  ClipboardCheck,
} from "lucide-react";
import OnboardingChecklist from "./OnboardingChecklist";
import EnhancedHeader from "./EnhancedHeader";
import Logo from "../images/thumbnail.png";

const CoreDashboard = () => {
  // State management
  const [user, setUser] = useState(null);
  const [userCredits, setUserCredits] = useState({
    question_credits: null,
    report_credits: null,
    video_credits: null,
    ideation_credits: null,
    lead_credits: null,
    plan_name: null,
    subscription_active: false,
    first_name: "Guest",
    email: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showWelcomeBanner, setShowWelcomeBanner] = useState(() => {
    const justCompletedOnboarding = localStorage.getItem("justCompletedOnboarding");
    if (justCompletedOnboarding) {
      localStorage.removeItem("justCompletedOnboarding");
      return true;
    }
    return false;
  });

  // White-label modal states
  const [showWhiteLabelModal, setShowWhiteLabelModal] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    email: "",
    role: "",
    clientsMonthly: "",
    businessPlans: false,
    leadGen: false,
    tiktokReels: false,
    other: false,
    additionalInfo: "",
  });

  const modalRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }

      if (modalRef.current && showWhiteLabelModal && !modalRef.current.contains(event.target)) {
        // Don't close modal when clicking outside if it's the success screen
        if (!formSuccess) {
          setShowWhiteLabelModal(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showWhiteLabelModal, formSuccess]);

  // Authentication check
  useEffect(() => {
    const token = localStorage.getItem("access");
    if (!token) {
      setIsLoading(false);
      window.location.href = "/signin/";
      return;
    }
    try {
      const decodedToken = jwtDecode(token);
      const currentTimestamp = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp < currentTimestamp) {
        console.warn("Token expired.");
        localStorage.removeItem("access");
        setIsLoading(false);
        window.location.href = "/signin/";
      } else {
        setUser(decodedToken);
        if (decodedToken.first_name) {
          setUserCredits((prev) => ({ ...prev, first_name: decodedToken.first_name }));
        }
      }
    } catch (error) {
      console.error("Failed to decode token:", error);
      localStorage.clear();
      setIsLoading(false);
      window.location.href = "/signin/";
    }
  }, []);

  // Fetch user credits
  useEffect(() => {
    if (user) {
      const fetchUserCredits = async () => {
        try {
          const response = await api.get("get-user-credits/");
          if (response.data) {
            setUserCredits({
              ...response.data,
              first_name: response.data.first_name || user.first_name || "User",
              email: response.data.email || user.email || "",
              question_credits: response.data.question_credits ?? 0,
              report_credits: response.data.report_credits ?? 0,
              video_credits: response.data.video_credits ?? 0,
              ideation_credits: response.data.ideation_credits ?? 0,
              lead_credits: response.data.lead_credits ?? 0,
            });

            // Prefill form with user data if available
            setFormData((prev) => ({
              ...prev,
              fullName: response.data.first_name || user.first_name || "",
              email: response.data.email || user.email || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching user credits:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchUserCredits();
    } else if (!localStorage.getItem("access")) {
      setIsLoading(false);
    }
  }, [user]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/signin/";
  };

  const handleOnboardingClose = () => {
    setShowOnboarding(false);
    localStorage.setItem("hasSeenOnboarding", "true");
  };

  // White-label form handlers
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleWhiteLabelSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitting(true);

    // Convert form data to format for submission
    const submitData = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (typeof value === "boolean") {
        // Only include checked boxes
        if (value === true) {
          submitData[key] = "Yes";
        }
      } else {
        submitData[key] = value;
      }
    });

    try {
      // Send to FormSubmit AJAX endpoint
      const response = await fetch("https://formsubmit.co/ajax/business@feedbackbyai.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(submitData),
      });

      const result = await response.json();

      if (result.success === "true" || result.success === true) {
        setFormSubmitting(false);
        setFormSuccess(true);
      } else {
        console.error("Form submission failed:", result);
        setFormSubmitting(false);
        alert("Something went wrong with your submission. Please try again.");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setFormSubmitting(false);
      alert("Something went wrong with your submission. Please try again.");
    }
  };

  const closeModal = () => {
    setShowWhiteLabelModal(false);
    // Reset form state after a delay
    setTimeout(() => {
      setFormSuccess(false);
    }, 300);
  };

  const openWhiteLabelModal = () => {
    setShowWhiteLabelModal(true);
    setFormSuccess(false);
  };

  // Card data with landing page style
  const actionCards = [
    // {
    //   id: "plan",
    //   icon: "📊",
    //   title: "Create a Business Plan",
    //   description: "Get a 100+ page personalized plan in minutes — market research, positioning, and more.",
    //   cta: "Create Your Plan →",
    //   path: "/dynamicreports",
    //   color: "green",
    //   glow: "shadow-[0_0_35px_-8px_rgba(34,197,94,0.25)]",
    //   hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(34,197,94,0.4)]",
    // },
    {
      id: "plan",
      icon: "📊",
      title: "Validate Idea with a Comprehensive 100+ Page Business Report",
      description:
        "Get utmost clarity with a 100+ page business report  personalized to your idea — use it for strategy, expansion or raising funds.",
      cta: "Create Your Plan",
      path: "/dynamicreports/",
      color: "green",
      glow: "shadow-[0_0_35px_-8px_rgba(34,197,94,0.25)]",
      hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(34,197,94,0.4)]",
    },
    {
      id: "leads",
      icon: "👥",
      title: "Real-Time Buyer Intent Search",
      description:
        "Discover high intent leads already searching for solutions like yours on Reddit, Twitter, and LinkedIn — all from one dashboard.",
      cta: "Discover Leads",
      isPopular: true,
      path: "/leadfinder",
      color: "purple",
      glow: "shadow-[0_0_35px_-8px_rgba(168,85,247,0.25)]",
      hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(168,85,247,0.4)]",
    },
    // {
    //   id: "leads",
    //   icon: "👥",
    //   title: "Real-Time Buyer Intent Search",
    //   description: "Find fresh leads searching for what you offer — updated every hour.",
    //   cta: "Search Leads →",
    //   path: "/leadfinder",
    //   isPopular: true,
    //   color: "purple",
    //   glow: "shadow-[0_0_35px_-8px_rgba(168,85,247,0.25)]",
    //   hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(168,85,247,0.4)]",
    // },
    // {
    //   id: "content",
    //   icon: "📱",
    //   title: "Launch Your AI Influencer",
    //   description: "Automate Reels, TikToks, and Shorts with 50+ avatars — just click, download, and post.",
    //   cta: "Create Videos →",
    //   path: "/video",
    //   color: "orange",
    //   glow: "shadow-[0_0_35px_-8px_rgba(249,115,22,0.25)]",
    //   hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(249,115,22,0.4)]",
    // },
    {
      id: "content",
      icon: "📱",
      title: "Launch Your AI Influencer",
      description:
        "Tiktoks and Reels now drive the most product awareness . Automate tiktoks at scale. 50+ Hyperrealistic avatars for your next tiktok. Automate in 3 clicks.",
      // "Your content team — without the overhead. Create daily TikToks, Reels, and Shorts using 50+ AI avatars. No camera, no editing, just scroll-stopping videos that convert.",
      cta: "Generate Videos",
      path: "/video",
      color: "orange",
      glow: "shadow-[0_0_35px_-8px_rgba(249,115,22,0.25)]",
      hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(249,115,22,0.4)]",
    },

    // {
    //   id: "brainstorm",
    //   icon: "🧪",
    //   title: " Brainstorm Opportunities",
    //   description: "Find real customer pain points and unmet needs from Reddit, Twitter & LinkedIn.",
    //   cta: "Start Discovering →",
    //   path: "/ideate",
    //   color: "blue",
    //   glow: "shadow-[0_0_35px_-8px_rgba(59,130,246,0.25)]",
    //   hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(59,130,246,0.4)]",
    // },

    {
      id: "brainstorm",
      icon: "🧪",
      title: "Brainstorm High-Impact Opportunities",
      description:
        "Find features, offers, and pain points worth solving. Tap into live social conversations to uncover real demand — not guesses.",
      cta: "Start Discovering",
      path: "/ideate",
      isPopular: false,
      color: "blue",
      glow: "shadow-[0_0_35px_-8px_rgba(59,130,246,0.25)]",
      hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(59,130,246,0.4)]",
    },
    {
      id: "whitelabel",
      icon: "🏢",
      title: "White-Label for Agencies, Consultants & Incubators",
      description: "Offer all 4 tools — business plans, lead gen, TikToks, and research — under your own brand, domain, and pricing.",
      cta: "Become a Partner →",
      action: openWhiteLabelModal, // Custom action instead of path
      color: "indigo",
      glow: "shadow-[0_0_35px_-8px_rgba(99,102,241,0.25)]",
      hoverGlow: "hover:shadow-[0_0_45px_-10px_rgba(99,102,241,0.4)]",
    },
  ];

  const colorClasses = {
    blue: {
      bg: "bg-white",
      border: "border-blue-200",
      text: "text-blue-900",
      hoverBg: "hover:bg-blue-50/50",
      hoverBorder: "hover:border-blue-400",
      iconBg: "bg-blue-100",
      iconText: "text-blue-600",
      ctaColor: "text-blue-600",
      hoverCtaColor: "group-hover:text-blue-700",
      gradientFrom: "from-blue-50/50",
      gradientTo: "to-transparent",
      popularRing: "ring-blue-500",
      popularText: "text-blue-700",
      popularBg: "bg-blue-100",
    },
    green: {
      bg: "bg-white",
      border: "border-green-200",
      text: "text-green-900",
      hoverBg: "hover:bg-green-50/50",
      hoverBorder: "hover:border-green-400",
      iconBg: "bg-green-100",
      iconText: "text-green-600",
      ctaColor: "text-green-600",
      hoverCtaColor: "group-hover:text-green-700",
      gradientFrom: "from-green-50/50",
      gradientTo: "to-transparent",
      popularRing: "ring-green-500",
      popularText: "text-green-700",
      popularBg: "bg-green-100",
    },
    purple: {
      bg: "bg-white",
      border: "border-purple-200",
      text: "text-purple-900",
      hoverBg: "hover:bg-purple-50/50",
      hoverBorder: "hover:border-purple-400",
      iconBg: "bg-purple-100",
      iconText: "text-purple-600",
      ctaColor: "text-purple-600",
      hoverCtaColor: "group-hover:text-purple-700",
      gradientFrom: "from-purple-50/50",
      gradientTo: "to-transparent",
      popularRing: "ring-purple-500",
      popularText: "text-purple-700",
      popularBg: "bg-purple-100",
    },
    orange: {
      bg: "bg-white",
      border: "border-orange-200",
      text: "text-orange-900",
      hoverBg: "hover:bg-orange-50/50",
      hoverBorder: "hover:border-orange-400",
      iconBg: "bg-orange-100",
      iconText: "text-orange-600",
      ctaColor: "text-orange-600",
      hoverCtaColor: "group-hover:text-orange-700",
      gradientFrom: "from-orange-50/50",
      gradientTo: "to-transparent",
      popularRing: "ring-orange-500",
      popularText: "text-orange-700",
      popularBg: "bg-orange-100",
    },
    indigo: {
      bg: "bg-white",
      border: "border-indigo-200",
      text: "text-indigo-900",
      hoverBg: "hover:bg-indigo-50/50",
      hoverBorder: "hover:border-indigo-400",
      iconBg: "bg-indigo-100",
      iconText: "text-indigo-600",
      ctaColor: "text-indigo-600",
      hoverCtaColor: "group-hover:text-indigo-700",
      gradientFrom: "from-indigo-50/50",
      gradientTo: "to-transparent",
      popularRing: "ring-indigo-500",
      popularText: "text-indigo-700",
      popularBg: "bg-indigo-100",
    },
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-12 h-12 text-blue-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen ">
      {showOnboarding && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <OnboardingChecklist
            onNavigate={(path) => {
              window.location.href = path;
            }}
            onClose={handleOnboardingClose}
          />
        </div>
      )}

      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-lg border-b border-gray-200">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex-shrink-0">
            <Link to="/dashboard" className="flex items-center">
              <img src={Logo} alt="FeedbackbyAI Logo" className="h-10" />
              <span className="ml-3 text-2xl font-bold text-green-600">FeedbackbyAI</span>
            </Link>
          </div>
          <div className="relative" ref={dropdownRef}>
            <button
              className="flex items-center px-4 py-2 text-base font-semibold text-gray-700 hover:text-gray-900 transition-colors"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <User className="w-6 h-6 mr-2" />
              {userCredits.first_name}
            </button>
            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg ring-1 ring-black/5 focus:outline-none z-50">
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-sm font-medium text-gray-900">{userCredits.first_name}</p>
                </div>
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-sm font-medium text-gray-900">{userCredits.email}</p>
                </div>
                <Link to="/credits" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                  <CreditCard className="w-4 h-4 mr-2" /> View Credits & Usage
                </Link>
                <button
                  onClick={() => setShowOnboarding(true)}
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  <Target className="w-4 h-4 mr-2" /> View Onboarding
                </button>
                <button
                  onClick={handleLogout}
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                >
                  <LogOut className="w-4 h-4 mr-2" /> Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <AnimatePresence>
        {showWelcomeBanner && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed top-20 left-1/2 transform -translate-x-1/2 z-30 mx-4"
          >
            <div className="bg-emerald-100 border border-emerald-300 text-emerald-800 px-6 py-3 rounded-lg shadow-lg flex items-center gap-4 max-w-lg">
              <div className="flex-grow">
                <p className="text-emerald-800 font-medium">
                  Welcome to your dashboard! You can always reopen the onboarding guide from your profile menu.
                </p>
              </div>
              <button onClick={() => setShowWelcomeBanner(false)} className="text-emerald-800 hover:text-emerald-600">
                <X className="w-5 h-5" />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="container mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Welcome, {userCredits.first_name !== "Guest" ? userCredits.first_name : "Explorer"}!
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">What would you like to do today?</p>
        </div>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { delayChildren: 0.3, staggerChildren: 0.18 } },
          }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-7 max-w-7xl mx-auto"
        >
          {actionCards.map((card) => {
            const colors = colorClasses[card.color];
            if (!colors) {
              console.warn(`Color definition missing for card color: ${card.color}. Skipping card.`);
              return null;
            }

            const handleCardClick = () => {
              if (card.action) {
                card.action();
              } else if (card.path) {
                window.location.href = card.path;
              }
            };

            return (
              <motion.div
                key={card.id}
                variants={{
                  hidden: { opacity: 0, scale: 0.95, y: 30 },
                  visible: { opacity: 1, scale: 1, y: 0, transition: { type: "spring", damping: 15, stiffness: 100 } },
                }}
                onClick={handleCardClick}
                className={`
                  rounded-2xl overflow-hidden border transition-all duration-200 
                  ${colors.bg} ${colors.border} ${colors.text} ${colors.hoverBg} ${colors.hoverBorder} 
                  ${card.glow} ${card.hoverGlow}
                  h-full cursor-pointer group relative
                `}
              >
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${colors.gradientFrom} ${colors.gradientTo} opacity-50 transition-opacity duration-200 group-hover:opacity-80`}
                />

                {card.isPopular && (
                  <div
                    className={`absolute top-4 right-4 px-3 py-1 rounded-full ${colors.popularBg} ${colors.popularText} text-xs font-semibold`}
                  >
                    Popular
                  </div>
                )}

                <div className="relative z-10 p-6 sm:p-8 flex flex-col h-full">
                  <div className={`w-14 h-14 mb-5 flex items-center justify-center rounded-2xl ${colors.iconBg} ${colors.iconText}`}>
                    <span className="text-2xl">{card.icon}</span>
                  </div>

                  <h3 className="text-lg font-bold mb-3">{card.title}</h3>

                  <p className="text-sm opacity-90 mb-6 flex-grow">{card.description}</p>

                  <div className={`flex items-center font-semibold text-sm ${colors.ctaColor} ${colors.hoverCtaColor} transition-colors`}>
                    {card.cta}
                    <ChevronRight className="h-5 w-5 inline transition-transform group-hover:translate-x-1" />
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.0 }}
          className="mt-12 max-w-xl mx-auto"
        >
          <div className="bg-white rounded-2xl p-6 text-center border border-gray-200 hover:border-blue-200 hover:shadow-[0_0_20px_-5px_rgba(59,130,246,0.2)] transition-all duration-300">
            <h2 className="text-lg font-bold text-gray-900 mb-2">Your Subscription</h2>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-100 text-green-700 text-sm font-medium mb-4">
              <CreditCard className="w-4 h-4" />
              {userCredits.plan_name || "Loading..."} Plan{" "}
              {!userCredits.subscription_active && userCredits.plan_name !== "Free" && userCredits.plan_name && (
                <span className="text-red-600">(Inactive)</span>
              )}
            </div>
            <p className="text-gray-600 mb-4">View credit details and usage limits</p>
            {userCredits.plan_name === "Free" && (
              <p className="text-sm text-blue-600 font-medium bg-blue-50 p-3 rounded-lg mb-4">
                Ready for more? Upgrade your plan to unlock powerful features and higher limits!
              </p>
            )}
            <Link
              to="/credits"
              className="inline-flex items-center px-4 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white transition-colors duration-200"
            >
              {userCredits.plan_name === "Free" ? "Upgrade Plan Now" : "Manage Subscription"}
              <ChevronRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </motion.div>
      </div>

      {/* White-label modal */}
      <AnimatePresence>
        {showWhiteLabelModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", damping: 20 }}
              className="bg-white rounded-xl shadow-2xl max-w-xl w-full overflow-hidden relative"
              ref={modalRef}
            >
              <button onClick={closeModal} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10">
                <X className="w-5 h-5" />
              </button>

              {formSuccess ? (
                <div className="p-8">
                  <div className="text-center mb-6">
                    <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                      <ClipboardCheck className="h-8 w-8 text-green-600" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">Thank You!</h3>
                    <p className="text-gray-600">
                      Your request for white-label access has been received. We're excited to explore this partnership!
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <h4 className="font-medium text-gray-900 mb-3">Here's what happens next:</h4>
                    <ul className="space-y-3">
                      <li className="flex items-start">
                        <div className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mt-0.5 mr-3">
                          <Mail className="w-4 h-4 text-indigo-600" />
                        </div>
                        <p className="text-sm text-gray-600">
                          You'll receive a confirmation email with details about our white-label program.
                        </p>
                      </li>
                      <li className="flex items-start">
                        <div className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mt-0.5 mr-3">
                          <Calendar className="w-4 h-4 text-indigo-600" />
                        </div>
                        <p className="text-sm text-gray-600">Our team will reach out within 48 hours to schedule a discovery call.</p>
                      </li>
                      {/* <li className="flex items-start">
                        <div className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mt-0.5 mr-3">
                          <Building className="w-4 h-4 text-indigo-600" />
                        </div>
                        <p className="text-sm text-gray-600">We'll create a personalized demo of your branded dashboard.</p>
                      </li> */}
                    </ul>
                  </div>

                  <button
                    onClick={closeModal}
                    className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-300"
                  >
                    Got it, thanks!
                  </button>
                </div>
              ) : (
                <>
                  <div className="p-6 sm:p-8 border-b border-gray-200 bg-indigo-50">
                    <div className="inline-flex items-center gap-2 bg-indigo-100 rounded-full px-4 py-1.5 text-sm text-indigo-800 font-medium mb-4">
                      <Building className="w-4 h-4" />
                      For Agencies, Consultants & Accelerators
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">🏢 White-Label FeedbackbyAI for Your Clients</h2>
                    <p className="text-gray-600">
                      Offer investor-ready business plans, lead generation & GTM content — all under your own brand, your own domain.
                    </p>
                  </div>

                  <div className="p-6 sm:p-8 max-h-[70vh] overflow-y-auto">
                    <form onSubmit={handleWhiteLabelSubmit} className="space-y-4">
                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1">
                            Full Name *
                          </label>
                          <input
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
                          />
                        </div>
                        <div>
                          <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1">
                            Company Name *
                          </label>
                          <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
                          />
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                            Email *
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
                          />
                        </div>
                        <div>
                          <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">
                            Your Role
                          </label>
                          <input
                            type="text"
                            id="role"
                            name="role"
                            value={formData.role}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
                          />
                        </div>
                      </div>

                      <div>
                        <label htmlFor="clientsMonthly" className="block text-sm font-medium text-gray-700 mb-1">
                          How many startups/clients do you serve monthly?
                        </label>
                        <select
                          id="clientsMonthly"
                          name="clientsMonthly"
                          value={formData.clientsMonthly}
                          onChange={handleInputChange}
                          className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
                        >
                          <option value="">Select an option</option>
                          <option value="1-5">1-5 clients</option>
                          <option value="6-10">6-10 clients</option>
                          <option value="11-20">11-20 clients</option>
                          <option value="21-50">21-50 clients</option>
                          <option value="51-100">51-100 clients</option>
                          <option value="100+">More than 100 clients</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          What would you use FeedbackbyAI for? (select all that apply)
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              id="businessPlans"
                              name="businessPlans"
                              checked={formData.businessPlans}
                              onChange={handleInputChange}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                            />
                            <label htmlFor="businessPlans" className="ml-2 text-sm text-gray-700">
                              Business Plans
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              id="leadGen"
                              name="leadGen"
                              checked={formData.leadGen}
                              onChange={handleInputChange}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                            />
                            <label htmlFor="leadGen" className="ml-2 text-sm text-gray-700">
                              Lead Gen
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              id="tiktokReels"
                              name="tiktokReels"
                              checked={formData.tiktokReels}
                              onChange={handleInputChange}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                            />
                            <label htmlFor="tiktokReels" className="ml-2 text-sm text-gray-700">
                              TikTok/Reels
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              id="other"
                              name="other"
                              checked={formData.other}
                              onChange={handleInputChange}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                            />
                            <label htmlFor="other" className="ml-2 text-sm text-gray-700">
                              Other
                            </label>
                          </div>
                        </div>
                      </div>

                      <div>
                        <label htmlFor="additionalInfo" className="block text-sm font-medium text-gray-700 mb-1">
                          Anything else you'd like us to know?
                        </label>
                        <textarea
                          id="additionalInfo"
                          name="additionalInfo"
                          value={formData.additionalInfo}
                          onChange={handleInputChange}
                          rows="2"
                          className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none"
                        ></textarea>
                      </div>

                      <button
                        type="submit"
                        disabled={formSubmitting}
                        className={`w-full py-3 bg-green-500 hover:bg-green-700 text-white font-medium rounded-lg transition-colors duration-300 ${
                          formSubmitting ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                      >
                        {formSubmitting ? (
                          <div className="flex items-center justify-center">
                            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                            Submitting...
                          </div>
                        ) : (
                          "Submit Interest"
                        )}
                      </button>
                    </form>
                  </div>
                </>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CoreDashboard;
